import React from 'react';
import { useReveal } from './hooks';

// Fades + lifts children in once they scroll into view. Pass `as` to change
// the wrapper tag (e.g. "li") and `delay` (ms) to stagger siblings.
const Reveal = ({ as: Tag = 'div', delay = 0, className = '', children, ...rest }) => {
  const [ref, isVisible] = useReveal();

  return (
    <Tag
      ref={ref}
      className={`dd-reveal ${isVisible ? 'dd-reveal--visible' : ''} ${className}`.trim()}
      style={{ transitionDelay: isVisible ? `${delay}ms` : '0ms' }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
